import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ConfigContext = createContext({
  calendly_url: "",
  shop_url: "https://jointsnjitsu.com",
  social: { instagram: "", youtube: "", tiktok: "" },
});

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState({
    calendly_url: "",
    shop_url: "https://jointsnjitsu.com",
    social: { instagram: "", youtube: "", tiktok: "" },
  });

  useEffect(() => {
    api.get("/config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  return <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
